import React from 'react';

export function BellIcon() {
  return (
    <svg
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_3168)">
        <path
          d="M13 33.9432C15.7733 33.9432 18.0214 31.6522 18.0214 28.8261C18.0214 26 15.7733 23.709 13 23.709C10.2267 23.709 7.97852 26 7.97852 28.8261C7.97852 31.6522 10.2267 33.9432 13 33.9432Z"
          fill="#06416A"
        />
        <path
          d="M13.0002 15.5786C16.7596 15.5786 19.8071 12.473 19.8071 8.64214C19.8071 4.81124 16.7596 1.70569 13.0002 1.70569C9.2409 1.70569 6.19336 4.81124 6.19336 8.64214C6.19336 12.473 9.2409 15.5786 13.0002 15.5786Z"
          fill="#00C4B3"
        />
        <path
          d="M23.3218 27.7458H2.73378C1.22734 27.7458 0.0556641 26.495 0.0556641 25.0167V22.7993H26.0557V25.0167C25.9999 26.495 24.8282 27.7458 23.3218 27.7458Z"
          fill="#00C4B3"
        />
        <path
          d="M21.8712 13.1906C20.588 11.9967 19.8627 10.3478 19.8627 8.58528V8.47157C19.8627 7.84615 19.3605 7.27759 18.691 7.27759H7.36481C6.75107 7.27759 6.19313 7.78929 6.19313 8.47157V8.58528C6.19313 10.3478 5.41202 11.9967 4.12876 13.1906C1.61803 15.6354 0 19.0468 0 22.913C0 23.8227 0.111588 24.6756 0.27897 25.5284C0.55794 26.8361 1.61803 27.7458 2.95708 27.7458H23.1545C24.4378 27.7458 25.5536 26.8361 25.7768 25.5853C25.9442 24.8461 26 24.107 26.0558 23.3679C26.1674 19.3311 24.4936 15.6923 21.8712 13.1906Z"
          fill="#00C4B3"
        />
        <path
          d="M12.9999 29.5652C20.1488 29.5652 25.9441 27.8597 25.9441 25.7558C25.9441 23.652 20.1488 21.9465 12.9999 21.9465C5.85098 21.9465 0.0556641 23.652 0.0556641 25.7558C0.0556641 27.8597 5.85098 29.5652 12.9999 29.5652Z"
          fill="#00C4B3"
        />
        <path
          d="M13.0001 4.32107C14.171 4.32107 15.1202 3.35377 15.1202 2.16054C15.1202 0.967304 14.171 0 13.0001 0C11.8291 0 10.8799 0.967304 10.8799 2.16054C10.8799 3.35377 11.8291 4.32107 13.0001 4.32107Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3168">
          <rect width="26" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
